import { createRootRoute, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ThemeProvider } from '@/contexts/ThemeContext'
import { AuthProvider } from '@/contexts/AuthContext'
import { RouteErrorBoundary } from '@/components/error/RouteErrorBoundary'
import { TooltipProvider } from '@/components/ui/tooltip'
import { Toaster } from 'sonner'
import { SpeedInsights } from '@vercel/speed-insights/react'
import { Analytics } from '@vercel/analytics/react'

const queryClient = new QueryClient()

export const Route = createRootRoute({
  component: RootLayout,
})

function RootLayout() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <TooltipProvider delayDuration={200}>
            <RouteErrorBoundary>
              <Outlet />
            </RouteErrorBoundary>
          </TooltipProvider>
          <Toaster position="top-right" richColors />
          {import.meta.env.PROD && <SpeedInsights />}
          {import.meta.env.PROD && <Analytics />}
          {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  )
}
